import React from 'react';
import TradingViewWidget from '../../../components/widgets/TradingViewWidget';

const Charts = () => {
  return (
    <div className="h-full w-full overflow-hidden bg-navy-900">
      {/* Disclaimer Banner */}
      <div className="w-full bg-blue-900/30 p-4 mb-4 rounded-lg">
        <div className="text-white text-center">
          <strong className="text-yellow-300">Disclaimer:</strong> Due to TradingView restrictions, invite-only scripts cannot be added here. 
          To use SyntiumAlgo scripts, you must log in to <a 
            href="https://www.tradingview.com/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-blue-400 hover:text-blue-300 underline"
          >TradingView</a> portal.
        </div>
      </div>
      
      {/* TradingView Widget */}
      <div className="relative h-full" style={{ height: "calc(100vh - 200px)" }}>
        <TradingViewWidget />
      </div>
    </div>
  );
};

export default Charts;
